import {Component, EventEmitter, Output} from '@angular/core';
import {UntypedFormControl, Validators} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {MDBModalRef} from 'ng-uikit-pro-standard';
import {IdAndLabel} from '../../../../common/model/id-and-label';
import {Localization} from '../../../../common/enums/localization';
import {AddCheckpointType} from "../../../../common/enums/enums";
import {take} from "rxjs/operators";

@Component({
  templateUrl: './select-checkpoint-creation-method-modal.component.html',
  styleUrls: ['./select-checkpoint-creation-method-modal.component.scss']
})
export class SelectCheckpointCreationMethodModal {

  private readonly selection$ = new EventEmitter<AddCheckpointType>();

  public readonly selection = this.selection$.pipe(take(1)).toPromise();

  public readonly Localization = Localization;
  public readonly items = Object.values(AddCheckpointType).map(type => new IdAndLabel(type, this.translate.instant(`addCheckpointType_${type}`)));
  public readonly creationMethodField = new UntypedFormControl(null, [Validators.required]);

  constructor(
    private translate: TranslateService,
    private readonly self: MDBModalRef,
  ) { }


  public close(){
    this.self.hide();
  }

  public onSubmit(){
    if (this.creationMethodField.valid) {
      this.selection$.emit(this.creationMethodField.value);
      this.self.hide();
    }
  }
}
